import moment from 'moment'
import {useState} from 'react'
import {useIntl} from 'react-intl'
import {CrudProvider} from '../../../services/loggedin/CrudContext'
import {ChartsComponent} from '../../parts/crud/Charts'
import {getBaseBarChartOptions} from '../../parts/crud/Types'
import {error} from 'console'
import {DataRangeFilter} from '../../parts/filters/DataRangeFilter'
import {ServerFilter} from '../../parts/filters/ServerFilter'
import {TimeDimensionGroupFilter} from '../../parts/filters/TimeDimensionGroupFilter'
import {EventCategoryFilter} from '../../parts/filters/EventCategoryFilter'

export const EventsByCategory = () => {
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const [filterData, setFilterData] = useState(null)
  const [dateRange, setDateRange] = useState({
    start: moment().subtract(6, 'days'),
    end: moment(),
  })
  const [server, setServer] = useState('all')
  const [groupSelected, setGroupSelected] = useState<any>(null)
  const [serversSelected, setServersSelected] = useState([])
  const [grouping, setGrouping] = useState('day')
  const [groupingOptionSelected, setGroupingOptionSelected] = useState<any>(null)
  const [error, setError] = useState('')
  const [eventCategory, setEventCategory] = useState(null)
  const [categorySelected, setCategorySelected] = useState<any>(null)
  const [error_category, setErrorCategory] = useState('')
  const submitData = async () => {
    let has_error = false
    setError('')
    if (
      server === 'oneormore' &&
      (serversSelected === null || (Array.isArray(serversSelected) && serversSelected.length === 0))
    ) {
      setError(intl.formatMessage({id: 'GENERIC.REQUIRED:SELECT_SERVER'}))
      has_error = true
    }
    setErrorCategory('')
    if (
      eventCategory === '0' &&
      (categorySelected === null ||
        (Array.isArray(categorySelected) && categorySelected.length === 0))
    ) {
      setErrorCategory(intl.formatMessage({id: 'GENERIC.REQUIRED:SELECT_CATEGORY'}))
      has_error = true
    }
    if (has_error) {
      return
    }
    let data: any = {
      date_range: {
        start: dateRange.start.format('YYYY-MM-DD') + ' 00:00:00',
        end: dateRange.end.format('YYYY-MM-DD') + ' 23:59:59',
      },
      tz: new Date().getTimezoneOffset(),
      server: server,
      group_list: groupSelected ? groupSelected.value : null,
      selected_server: serversSelected ? serversSelected.map((srv: any) => srv.value) : [],
      eventcat_selected:
        eventCategory === '0' && categorySelected
          ? categorySelected.map((cat: any) => cat.value)
          : [],
      group_dimension: grouping==="1" && groupingOptionSelected ? groupingOptionSelected.value : '',
      grouping: grouping,
    }
    setFilterData(data)
  }
  let params: any = {
    title: intl.formatMessage({id: 'REPORT_DEVICE.EVENTS_BY_CATEGORY.TITLE'}),
    subtitle: intl.formatMessage({id: 'REPORT_DEVICE.EVENTS_BY_CATEGORY.SUBTITLE'}),
   

    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    pointFormat:
      '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.0f} </b></td></tr>',
    footerFormat: '</table>',
    shared: true,
    useHTML: true,
  }
  let baseChartOptions: any = {...getBaseBarChartOptions(params)}
  baseChartOptions.plotOptions = {
    column: {
      stacking: 'normal',
      minPointLength: 8,
    },
    area: {
      fillOpacity: 0.5,
    },
  }
  baseChartOptions.yAxis = {
    title: {
      text: '# WEvents',
    },
    min: 0,
    type: 'linear',
    labels: {
      
    },
  }
  return (
    <>
      <CrudProvider api='reports/category'>
        <ChartsComponent
          setLoading={(loading) => {
            setLoading(loading)
          }}
          filterData={filterData}
          baseChartOptions={baseChartOptions}
        >
          <p>{intl.formatMessage({id: 'REPORT_DEVICE.EVENTS_BY_CATEGORY.TEXT'})}</p>
          <DataRangeFilter
            onChangedDataRange={(start, end) => {
              setDateRange({
                start: start,
                end: end,
              })
            }}
          />
          <TimeDimensionGroupFilter
            onChangedGrouping={(grouping) => {
              setGrouping(grouping)
            }}
            onChangedGroupingOption={(groupingOptionSelected) => {
              setGroupingOptionSelected(groupingOptionSelected)
            }}
          />
          <ServerFilter
            onChangedServer={(server) => {
              setServer(server)
            }}
            onChangedServersSelected={(servers) => {
              setServersSelected(servers)
            }}
            onGroupSelected={(group) => {
              setGroupSelected(group)
            }}
          />
          {error && <div className='alert alert-danger'>{error}</div>}
          <EventCategoryFilter
            onChangedEventCategory={(eventCategory: any) => {
              setEventCategory(eventCategory)
            }}
            onChangedCategorySelected={(categorySelected: any) => {
              setCategorySelected(categorySelected)
            }}
          />
          {error_category && <div className='alert alert-danger'>{error_category}</div>}
          <input
            type='button'
            disabled={loading}
            className='btn btn-primary'
            onClick={submitData}
            value={intl.formatMessage({id: 'GENERIC.SUBMIT'})}
            style={{float:"left"}}
          />{' '}
          {loading && <div className='spinner-border text-primary' role='status' style={{marginTop: '7px',float:"left",marginLeft:"10px"}}>
                <span className='visually-hidden'>Loading...</span>
              </div>}
        </ChartsComponent>
      </CrudProvider>
    </>
  )
}
